export function WorkspacePage() {
  // The Retool iframe lives in AppShell (RetoolEmbed), not here.
  // This route is an empty placeholder — the shell toggles iframe visibility via CSS.
  return null;
}
